import { classnames } from '@/utils/classnames/classnames';
import { TableRowProps } from '../types';
import React from 'react';

const TableRow = React.forwardRef<HTMLTableRowElement, TableRowProps>(
  ({ className, ...props }, ref) => {
    const rowClassName = classnames(
      'whitespace-nowrap shadow-[0px_-1px_0px_0px_#E4E4E7_inset] last:shadow-none',
      className,
    );

    return <tr ref={ref} className={rowClassName} {...props} />;
  },
);

TableRow.displayName = 'TableRow';

export default TableRow;